export default "__VITE_ASSET__DRyk5YG8__"